import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Star, Quote } from "lucide-react";
import { Link } from "react-router-dom";

export default function HubReviewsTicker() {
  const [reviews, setReviews] = useState([]);
  const [idx, setIdx] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    api
      .get("/reviews")
      .then((r) => setReviews((r.data || []).slice(0, 5)))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (reviews.length < 2) return;
    const id = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setIdx((i) => (i + 1) % reviews.length);
        setFade(true);
      }, 300);
    }, 6000);
    return () => clearInterval(id);
  }, [reviews.length]);

  if (reviews.length === 0) return null;
  const r = reviews[idx];

  return (
    <Link
      to="/reviews"
      data-testid="hub-reviews-ticker"
      className="mt-6 w-full max-w-2xl mx-auto block text-center group"
    >
      <div
        className={`transition-opacity duration-300 ${fade ? "opacity-100" : "opacity-0"}`}
      >
        <Quote className="w-4 h-4 mx-auto text-[var(--trio-primary)]/50 mb-2" />
        <div className="flex justify-center gap-0.5 mb-2">
          {Array.from({ length: 5 }).map((_, s) => (
            <Star
              key={s}
              className={`w-3 h-3 ${
                s < r.rating
                  ? "fill-[var(--trio-accent)] text-[var(--trio-accent)]"
                  : "text-[var(--trio-border)]"
              }`}
            />
          ))}
        </div>
        <p className="font-serif italic text-sm sm:text-base leading-snug text-[var(--trio-text)] max-w-lg mx-auto line-clamp-2 px-2">
          “{r.message}”
        </p>
        <div className="mt-1.5 text-[10px] tracking-[0.3em] uppercase text-[var(--trio-muted)]">
          — {r.name}
          {reviews.length > 1 && (
            <span className="ml-3 text-[var(--trio-muted)]/50">
              {idx + 1} / {reviews.length}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
